module.exports = __webpack_public_path__ + "static/media/htmlIconWhite.feabd912.svg";